import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Home, Search } from 'lucide-react';
import { Container, Button } from '../styles/GlobalStyles';
import { theme } from '../styles/theme';

const NotFoundContainer = styled.div`
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const NotFoundContent = styled.div`
  max-width: 500px;
`;

const ErrorCode = styled.div`
  font-size: 6rem;
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing[4]};
  opacity: 0.8;

  @media (max-width: ${theme.breakpoints.sm}) {
    font-size: 4rem;
  }
`;

const ErrorTitle = styled.h1`
  margin-bottom: ${theme.spacing[4]};
  color: ${theme.colors.textPrimary};
`;

const ErrorDescription = styled.p`
  color: ${theme.colors.textSecondary};
  font-size: ${theme.typography.fontSize.lg};
  line-height: ${theme.typography.lineHeight.relaxed};
  margin-bottom: ${theme.spacing[8]};
`;

const ActionButtons = styled.div`
  display: flex;
  gap: ${theme.spacing[4]};
  justify-content: center;

  @media (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <NotFoundContainer>
      <Container>
        <NotFoundContent>
          <ErrorCode>404</ErrorCode>
          <ErrorTitle>Page Not Found</ErrorTitle>
          <ErrorDescription>
            Sorry, the page you're looking for doesn't exist. It might have been moved, 
            deleted, or you entered the wrong URL.
          </ErrorDescription>
          <ActionButtons>
            <Button onClick={handleGoHome}>
              <Home size={20} />
              Go Home
            </Button>
            <Button $variant="outline" onClick={handleGoBack}>
              <Search size={20} />
              Go Back
            </Button>
          </ActionButtons>
        </NotFoundContent>
      </Container>
    </NotFoundContainer>
  );
};

export default NotFoundPage;